import React from 'react';
import './Background.css';

const Background = () => {
  return (
    <div className="background-wrapper">
      {/* Grid pattern background */}
      <div className="grid-background"></div>
    </div>
  );
};

export default Background;
